import { DefaultStatistic, StatisticType } from 'Shared/molecules/Statistic/types'

import i18n from 'Portals/Customer/utils/i18nService'

export const defaultStatistic: DefaultStatistic[] = [
	{
		title: i18n.t('pages:order.statistic.accepted'),
		type: StatisticType.green
	},
	{
		title: i18n.t('pages:order.statistic.waitingForResponse'),
		type: StatisticType.blue
	},
	{
		title: i18n.t('pages:order.statistic.submitted'),
		type: StatisticType.orange
	},
	{
		title: i18n.t('pages:order.statistic.declinedBySupplier'),
		type: StatisticType.red
	},
	{
		title: i18n.t('pages:order.statistic.rejected'),
		type: StatisticType.grey
	},
	{
		title: i18n.t('pages:order.statistic.total'),
		type: StatisticType.lightGrey
	}
]
